<template>

  <div class="home">
    <navbar :is-active="2"></navbar>
    <div class="body">
      <div class="body__sidebar">
        <div class="floating-icon">
          <i class="fas fa-arrow-alt-circle-left"></i>
        </div>
        <div class="title">
          <div class="title__icon">
            <i class="fas fa-home"></i>
          </div>
          <div class="title__text">
            <h2>Menu QuickPay</h2>
            <p>Selecciona una opción</p>
          </div>
        </div>
        <div class="tabs">
          <a href="/Client/cp-productos" class="tab">
            <div class="tab__icon">
              <i class="fab fa-product-hunt"></i>
            </div>
            <div class="tab__text">
              <p>Productos</p>
            </div>
          </a>
          <a href="#" class="tab active">
            <div class="tab__icon">
              <i class="fas fa-user-friends"></i>
            </div>
            <div class="tab__text">
              <p>Clientes</p>
            </div>
          </a>
          <a href="/Client/cp-boletas" class="tab">
            <div class="tab__icon">
              <i class="fas fa-file-invoice-dollar"></i>
            </div>
            <div class="tab__text">
              <p>Boletas</p>
            </div>
          </a>
        </div>
      </div>
      <div class="body__containt">
        <div class="page__title">
          <h2>Clientes</h2>
        </div>

        <div class="page__filters">

          <input @blur="searchBranchOffice" type="text" v-model="fecha_cp_fin_3" placeholder="Código de cliente">
          <input @blur="searchBranchOffice" type="text" v-model="fecha_cp_fin_3" placeholder="Código boleta quickshop">
          <input @blur="searchBranchOffice" type="text" v-model="fecha_cp_fin_3" placeholder="Código boleta cliente">

          <div style="display: flex; width: 100%;">
            <label style="padding-right: 23%;">Fecha de compra</label>
            <label style="padding-right: 23%;">Fecha de validación</label>
          </div>
          <input @blur="searchBranchOffice" style="width: 15%;" type="text" v-model="fecha_cp_inicio_1" placeholder="Fecha desde">
          <input @blur="searchBranchOffice" style="width: 15%;" type="text" v-model="fecha_cp_fin_1" placeholder="Fecha hasta">
          <input @blur="searchBranchOffice" style="width: 15%;" type="text" v-model="fecha_cp_inicio_2" placeholder="Fecha desde">
          <input @blur="searchBranchOffice" style="width: 15%;" type="text" v-model="fecha_cp_fin_2" placeholder="Fecha hasta">

        </div>
        <div class="page__buttons">
          <button class="button">Exportar <i class="fas fa-chevron-down"></i></button>
        </div>
        <div class="page__table">
          <div class="table-headers">
            <p>Código de cliente</p>
            <p>Nombres</p>
            <p>Apellidos</p>
            <p>Correo electrónico</p>
            <p>Celular</p>
            <p>Accion</p>
          </div>
          <div class="table-body">
            <div class="data" >
              <p>000000123</p>
              <p>Erick</p>
              <p>Carrasco Guevara</p>
              <p>erick@gmail.com</p>
              <p>957057878</p>
              <p @click="deleteBranchOffice(branch.id)"><i class="fa fa-ellipsis" style="color: red"></i></p>
            </div>
            <div class="data" >
              <p>000000123</p>
              <p>Erick</p>
              <p>Carrasco Guevara</p>
              <p>erick@gmail.com</p>
              <p>957057878</p>
              <p @click="deleteBranchOffice(branch.id)"><i class="fa fa-ellipsis" style="color: red"></i></p>
            </div>
            <div class="data" >
              <p>000000123</p>
              <p>Erick</p>
              <p>Carrasco Guevara</p>
              <p>erick@gmail.com</p>
              <p>957057878</p>
              <p @click="deleteBranchOffice(branch.id)"><i class="fa fa-ellipsis" style="color: red"></i></p>
            </div>
            <div class="data" >
              <p>000000123</p>
              <p>Erick</p>
              <p>Carrasco Guevara</p>
              <p>erick@gmail.com</p>
              <p>957057878</p>
              <p @click="deleteBranchOffice(branch.id)"><i class="fa fa-ellipsis" style="color: red"></i></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Navbar from "../../../components/NavBar";

export default {
  name: 'Clientes',
  components: {
    Navbar
  },
  data() {
    return {
      branch_code: '',
      branch_nickname: '',
      txt_pais: 'Peru',
      branch_pro_id: '',
      branch_dis_id: '',
      branch_status: 0,
      branchoffice:[],

      fecha: '',
      usuario: '',
      list: [],
    }
  },
  mounted() {
    this.basicInfo()
    if (localStorage.getItem('token')){
      this.getall()
    }else{
      this.$router.push('/login');
    }
  },
  methods:{
    handleClick(){
      localStorage.removeItem('token')
      this.$router.push('/login');
    },
    getall(){
      let result = axios
          .get("general/branchoffice")
          .then(res => {
            this.branchoffice = res.data.data
          })
    },
    AddSucursal(){
      this.$router.push('/Client/AddBranchOffice');
    },
    showBranchOffice(id){
      this.$router.push({ path: '/Client/ShowBranchOffice', query: { id: id } })
    },
    deleteBranchOffice(branch_id){
      this.$swal({
        title: '¿Estas seguro de eliminar el sucursal?',
        text: "",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          let result = axios
              .delete("general/branchoffice/"+branch_id)
              .then(res => {
                console.log(res)
                if(res.data.success){
                  this.$swal({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Se elimino correctamente',
                    showConfirmButton: false,
                    timer: 2000
                  })
                  this.$router.go(0)
                }else{
                  this.$swal({
                    position: 'top-end',
                    icon: 'error',
                    title: 'Ocurrio un problema',
                    showConfirmButton: false,
                    timer: 2000
                  })
                }
              })
        }
      })
    },
    searchBranchOffice(){
      console.log("ingreso");
      // this.branchoffice = []

    },
    basicInfo(){
      this.usuario = localStorage.getItem('usuario')
      this.list = JSON.parse(localStorage.getItem("getListOfMenu"));
      console.log(this.list)
      this.getDate()
    },
    getDate(){

      let dias = ["Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado","Domingo"];
      let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

      let date = new Date();

      var fechaNum = date.getDate();
      var mes_name = date.getMonth();


      this.fecha =  dias[date.getDay()-1] + " " + this.zeroFill(fechaNum, 2) + " de " + meses[mes_name];
    },
    zeroFill( number, width )
    {
      width -= number.toString().length;
      if ( width > 0 )
      {
        return new Array( width + (/\./.test( number ) ? 2 : 1) ).join( '0' ) + number;
      }
      return number + "";
    },
    url(path){
      this.$router.push(path)
    }
  }
}


</script>

<style scoped>

/*------NAVBAR------*/
.home .navbar {
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #dbdbdb;
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.05);
}

.home .navbar__left {
  width: 200px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.home .navbar__left img {
  width: 130px;
}

.home .navbar__center {
  width: 70%;
  height: 100%;
}

.home .navbar__center ul{
  width: 100%;
  height: 100%;
  display: flex;
  list-style: none;
  display: flex;
  justify-content: flex-start;
}
.home .navbar__center ul li {
  text-decoration: none;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  position: relative;
  cursor: pointer;
}

.home .navbar__center ul li.active {
  color: #ff3128;
}
.home .navbar__center ul li.active::before {
  width: 100%;
}

.home .navbar__center ul li::before {
  content: '';
  position: absolute;
  bottom: 0;
  width: 0;
  height: 4px;
  background-color: #ff3128;
  transition: .3s ease;
}
.home .navbar__center ul li:hover {
  color: #ff3128;
}
.home .navbar__center ul li:hover::before {
  width: 100%;
}

.home .navbar__right {
  display: flex;
}
.home .navbar__right .profile {
  display: flex;
  width: 300px;
  height: 100%;
}

.home .navbar__right .profile__detail{
  width: 220px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 5px;
}
.home .navbar__right .profile__detail p {
  margin: 0;
}
.home .navbar__right .profile__detail span {
  color: #938f8f;
  font-weight: 300;

}

.home .navbar__right .profile__icon,
.home .navbar__right .profile__logout {
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  color: #ff3128;
  cursor: pointer;
}
/*------NAVBAR------*/


.home {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'Readex Pro', sans-serif;
}
/*-------------------------*/
/*-------------------------*/

/*------BODY------*/

.body {
  width: 100%;
  height: 600px;
  display: flex;

}
.body__sidebar,
.body__containt  {
  height: calc(100vh - 120px);
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
}
.body__sidebar {
  width: 400px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.body__sidebar .floating-icon {
  position: absolute;
  right: -15px;
  top: 30px;
  color: #ff3128;
  font-size: 30px;
}

.body__sidebar .title {
  width: 100%;
  height: 140px;
  border-bottom: 1px solid #b6b6b6;
  display: flex;
  align-items: center;
  justify-content: center;
}
.body__sidebar .title__icon {
  color: #ff3128;
  font-size: 20px;
}
.body__sidebar .title__text {
  margin: 0 10px;

}

.body__sidebar .title__text h2 {
  font-size: 20px;
  margin: 0;
}
.body__sidebar .title__text p {
  margin: 0;
  font-weight: 300;
}

.body__sidebar .tabs {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 140px);
  padding-top: 5px;
}

.body__sidebar .tabs .tab {
  width: 90%;
  height: 70px;
  border-radius: 10px;
  color: #707070;
  display: flex;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: 0.3 ease;
}
.body__sidebar .tabs .tab:hover,
.body__sidebar .tabs .tab.active {
  color: #ff3128;
  background: #ffeeed;
}

.body__sidebar .tabs .tab__icon {
  font-size: 20px;
  margin-right: 10px;
}

.body__sidebar .tabs .tab__text p{
  margin: 0;
  font-weight: 600;
}

.body__containt {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
}

.body__containt .page__title {
  width: 100%;
  margin-bottom: 20px;
}

.body__containt .page__title h2 {
  font-weight: 600;
  color: #ff3128;
  font-size: 25px;
}

.body__containt .page__filters {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;
}
.body__containt .page__filters input, select {
  border-radius: 10px;
  border: 1px solid #e4e4e4;
  background: #fff;
  padding: 15px 20px;
  /*margin: 0 10px;*/
  width: 300px;
}

.body__containt .page__buttons {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  padding-top: 2%;
}

.body__containt .page__buttons .button {
  width: 250px;
  padding: 15px 20px;
  border-radius: 15px;
  font-size: 17px;
  color: #fff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.body__containt .page__buttons .button:nth-child(1) {
  background: #262626;
}

.body__containt .page__table {
  width: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  margin-top: 50px;
}

.body__containt .page__table .table-headers {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #b6b6b6;
}
.body__containt .page__table .table-headers p {
  width: calc(100% / 7);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
}

.body__containt .page__table .table-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #b6b6b6;
}

.body__containt .page__table .table-body .data {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.body__containt .page__table .table-body .data p {
  width: calc(100% / 7);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 300;
  margin: 10px 0;
}
.body__containt .page__table .table-body .data p:nth-child(1) {
  color: #ff3128;
}
/*.body__containt .page__filters input:nth-child(1) {*/
/*  width: 300px;*/
/*  margin: 0;*/
/*  margin-right: 10px;*/
/*}*/


/*------BODY------*/


</style>
